/** Taxa do passo fixo de simulação e de input (ADR 0003). */
export const TICK_RATE = 30;
/** Sub-passos de física por tick: física a TICK_RATE × SUB_STEPS Hz. */
export const SUB_STEPS = 2;
export const STEP_SECONDS = 1 / TICK_RATE;
export const SUB_STEP_SECONDS = STEP_SECONDS / SUB_STEPS;
/** Intervalo de envio de patches de estado. */
export const PATCH_RATE_MS = 50;
